module.exports = __webpack_public_path__ + "static/img/xaas-banner.743d5890.png";